import React from "react";
// @ts-ignore
import ReactDOMClient from "react-dom/client";
import {CalculatorScreen} from "./CalculatorScreen";
import './index.scss';
const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<CalculatorScreen/>);
